module.exports = __webpack_public_path__ + "e6ba080cb2c6e20ca1fee6c58fe683cd.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/bell-tower.png
// module id = 549
// module chunks = 0